export default __webpack_public_path__ + "static/media/logofooterimg.84162aec.png";